import React, {useState} from "react"
import {defineMessages, injectIntl} from "react-intl"
import {INTEGRATION_KEY} from "../../state/integration/Constants"
import UseModal from "../../common/hooks/UseModal"
import {Intl} from "../../state/helpers/IntlProps"
import {FeatureContactImport} from "../../state/integration/IntegrationFeatureKeys"
import IntegrationSelect from "../../integration/integrationSelect.component"
import {AppContext} from "@lightspeed-invoicing/core-client/frontend/index"

const messages = defineMessages({
    header: {
        id: "customer.modal.header",
        defaultMessage: "Import Contacts"
    },
    start: {
        id: "customer.modal.start",
        defaultMessage: "Start now"
    }
})

type Props = {
    intl: Intl
    integrationKey: INTEGRATION_KEY
    onCloseCallback: () => void
}

const ImportContactsModal = (props: Props) => {
    const [selectedOption, setSelectedOption] = useState(
        {
            integrationKey: props.integrationKey,
            integrationConfigurationId: "",
        })

    const body = (
        <div>
            <IntegrationSelect
                supportedFeature={FeatureContactImport}
                multi={false}
                defaultInputValue={props.integrationKey}
                value={props.integrationKey}
                onChange={(integrationKey, _, metadata) => {
                    setSelectedOption({
                        integrationKey: integrationKey,
                        integrationConfigurationId: metadata?.integration?.id,
                    })
                }}
            />
        </div>
    )

    const onImportStart = () => {
        AppContext.getApiClient().post("/imports", {
            ...selectedOption,
            type: "contacts",
        }).then(() => {
            props.onCloseCallback()
        })
    }

    const {modal, hasClosed, hasConfirmed, setSubmitDisabled} = UseModal({
        show: true,
        header: props.intl.formatMessage(messages["header"]),
        body: body,
        bodyStyle: {overflow: "visible"},
        showConfirmBtn: true,
    })

    if (hasConfirmed) {
        onImportStart()
    } else if (hasClosed) {
        props.onCloseCallback()
    }

    setSubmitDisabled(selectedOption.integrationKey === "")

    return (
        <>
            {modal}
        </>
    )
}

export default injectIntl(ImportContactsModal)


// WEBPACK FOOTER //
// ./src/customer/modal/ImportContactsModal.tsx